import React from 'react';

import { User } from '@/core/api/collections/users';

// logic adapted from admin
function getInitials({ displayName, email }: User) {
  if (!displayName) {
    // Use the first character of email as a fallback if it's a word character and not a digit
    return email.charAt(0).replace(/[\W,\d]/, '');
  }
  // Remove any words surrounded by non-word characters ie: `Bobby (Joe) Smith`
  // eslint-disable-next-line no-control-regex
  let name = displayName.replace(/ ?(\[.*]|\(.*\)|{.*}|([^\w\s]).*\2)|[^\x00-\x7F]+/g, '');
  // Remove any words that don't start with a word character ie: `[!@#`
  name = name.replace(/(^| )[^\w\s]\w*/g, '').trim();
  // Remove any words that start with a digit ie: `1st Place Sidson`
  name = name.replace(/\b\d\w* ?/g, '');
  const parts = name.split(/[\s.]/g);
  const first = parts.shift();
  const last = parts.pop();
  return first ? first.charAt(0) + (last ? last.charAt(0) : '') : '';
}

type Props = {
  user: User;
};
export function Avatar({ user }: Props) {
  return (
    <div
      className="relative flex items-center justify-center w-full h-full overflow-hidden bg-blue-900 rounded-full box-border"
      aria-hidden
    >
      {user.avatarUrl  && <img className="absolute" src={user.avatarUrl} alt="" />}
      <span className="font-normal tracking-wider text-blue-100 uppercase pl-0.5">
        { getInitials(user) }
      </span>
    </div>
  );
}
